module.exports = __webpack_public_path__ + "media/Ż.29ded9c7.mp3";